/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiPermission, ApiUser, LockElement, LockedContextDto } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of UsersController.
 */
export class UsersRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /users/{userId}:activate
     */
    public activateUser(userId: string): Promise<Result<ApiUser>> {
        return this.http.post<Result<ApiUser>, undefined>(`/users/${userId}:activate`, undefined);
    }

    /**
     * Calls POST /users/{userId}:reset_password
     */
    public resetUserPassword(userId: string): Promise<Result<boolean>> {
        return this.http.post<Result<boolean>, undefined>(`/users/${userId}:reset_password`, undefined);
    }

    /**
     * Calls POST /users/{userId}:block
     */
    public blockUser(userId: string): Promise<Result<boolean>> {
        return this.http.post<Result<boolean>, undefined>(`/users/${userId}:block`, undefined);
    }

    /**
     * Calls POST /users/{userId}:unblock
     */
    public unblockUser(userId: string): Promise<Result<boolean>> {
        return this.http.post<Result<boolean>, undefined>(`/users/${userId}:unblock`, undefined);
    }

    /**
     * Calls GET /users/{userId}/permissions
     */
    public getUserPermissions(userId: string): Promise<Result<ApiPermission[]>> {
        return this.http.get<Result<ApiPermission[]>>(`/users/${userId}/permissions`);
    }

    /**
     * Calls POST /users:prefill
     */
    public createPrefilled(): Promise<Result<ApiUser>> {
        return this.http.post<Result<ApiUser>, undefined>('/users:prefill', undefined);
    }

    /**
     * Calls POST /users/{primaryId}/start_edit_mode
     */
    public startEditMode(primaryId: string): Promise<Result<LockedContextDto<ApiUser>>> {
        return this.http.post<Result<LockedContextDto<ApiUser>>, undefined>(`/users/${primaryId}/start_edit_mode`, undefined);
    }

    /**
     * Calls POST /users/{draftId}/commit
     */
    public commitDraft(draftId: string): Promise<Result<ApiUser>> {
        return this.http.post<Result<ApiUser>, undefined>(`/users/${draftId}/commit`, undefined);
    }

    /**
     * Calls POST /users/locks
     */
    public lockAll(ids: string[]): Promise<Result<ApiUser[]>> {
        return this.http.post<Result<ApiUser[]>, string[]>('/users/locks', ids);
    }

    /**
     * Calls POST /users/{primaryId}/locks
     */
    public lock(primaryId: string): Promise<Result<LockElement>> {
        return this.http.post<Result<LockElement>, undefined>(`/users/${primaryId}/locks`, undefined);
    }

    /**
     * Calls DELETE /users/{primaryId}/locks
     */
    public unlock(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/users/${primaryId}/locks`);
    }

    /**
     * Calls GET /users/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiUser>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiUser>>(`/users/${primaryId}`, query);
    }

    /**
     * Calls POST /users
     */
    public add(dto: ApiUser): Promise<Result<ApiUser>> {
        return this.http.post<Result<ApiUser>, ApiUser>('/users', dto);
    }

    /**
     * Calls PUT /users/{primaryId}
     */
    public update(dto: ApiUser, primaryId: string): Promise<Result<ApiUser>> {
        return this.http.put<Result<ApiUser>, ApiUser>(`/users/${primaryId}`, dto);
    }

    /**
     * Calls PATCH /users
     */
    public putRange(dtos: ApiUser[]): Promise<Result<ApiUser[]>> {
        return this.http.patch<Result<ApiUser[]>, ApiUser[]>('/users', dtos);
    }

    /**
     * Calls DELETE /users/{primaryId}
     */
    public delete(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/users/${primaryId}`);
    }

    /**
     * Calls POST /users:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiUser>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiUser>>, ListRequestWithIds>('/users:batch', listRequest, query);
    }

    /**
     * Calls POST /users:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiUser>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiUser>>, ListRequest>('/users:query', listRequest, query);
    }

    /**
     * Calls GET /users:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiUser>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiUser>>>('/users:query', query);
    }
}
